import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "initials",
    pure: true
})
export class InitialsPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return "";
        }

        return (
            value
                ?.split(" ")
                ?.slice(0, 2)
                .reduce((acc, cur) => acc + cur[0].toUpperCase(), "") || ""
        );
    }
}
